// Where in the town each of his websites is offered.
//
// Stand by the printers and the town says "he keeps a page about this
// place"; stand at a wall, the graffiti guide; in the studio, the cats.
// The door is only there while the site is live: an archived page keeps
// its address on his home index and loses its door in the world, which
// is the "if the website gets removed, we remove this action" rule with
// nothing actually removed.
//
// Imports nothing, like placeActions, so the sim could read it too.

export const SITE_PLACES = {
  activity3DPrinters: { title: 'the print workshop', kinds: ['prints'] },
  studio: { title: 'the studio', kinds: ['cats', 'sketches'] },
  artWall: { title: 'the art wall', kinds: ['cats'] },
  tagging_01: { title: 'the wall', kinds: ['graffiti'] },
  tagging_02: { title: 'the wall', kinds: ['graffiti'] },
  tagging_03: { title: 'the wall', kinds: ['graffiti'] },
  tagging_04: { title: 'the wall', kinds: ['graffiti'] },
  tagging_05: { title: 'the wall', kinds: ['graffiti'] },
  tagging_06: { title: 'the wall', kinds: ['graffiti'] },
  tagging_08: { title: 'the wall', kinds: ['graffiti'] },
  tagging_09: { title: 'the wall', kinds: ['graffiti'] },
}

export const SITE_PLACE_NAMES = Object.keys(SITE_PLACES)

/** The live sites the town offers at this place, in the place's own order. */
export function sitesAt(place, sites = []) {
  const spec = SITE_PLACES[place]
  if (!spec || !Array.isArray(sites)) return []
  const out = []
  for (const kind of spec.kinds) {
    for (const s of sites) if (s && s.kind === kind && !s.archived && s.url && !out.includes(s)) out.push(s)
  }
  return out
}
